<template>
	<sTable
		ref="tab"
		actionRead="inject"
		:preRequestData="preRequestData"
		:totalRegistros="totalRegistros"
		:tableStriped="false"
		:tableHover="false"
		:functions="functions"
		:labels="labels"
		:lineStatus="fxStatus"
		:block="true"
		:actions="actions"
		no-pager
		@settings_os="(r) => $refs.compForm.open(r)"
	/>
</template>
<script>
	import sTable from 'table';
	import eDate from 'js/date';
	import cmpActions from '../actions.vue';

	export default {
		props: ['preRequestData', 'totalRegistros'],
		components: {
			cmpActions,
			sTable,
		},
		data() {
			return {
				actions: cmpActions,
				labels: [
					{
						data: ['cod', 'contrato'],
						icon: ['fa fa-cog', 'fa fa-file-text-o'],
						label: 'Códigos',
						two: true,
					},
					{
						data: ['dInicio', 'duracao'],
						icon: [
							'fa fa-calendar-check-o',
							'fa fa-calendar-times-o',
						],
						label: 'Previsão',
						two: true,
					},
					{
						data: ['dComeco', 'dTermino'],
						icon: [
							'fa fa-calendar-check-o',
							'fa fa-calendar-times-o',
						],
						label: 'Execução',
						two: true,
					},
					{
						data: ['servico', 'tarefa'],
						label: 'Serviço/Tarefa',
						two: true,
					},
					{ data: ['cliente', 'cnpj'], label: 'Cliente', two: true },
					{ data: ['regiao'], label: 'Região' },
				],
				functions: [
					{
						cod: 'contrato',
						fx: (val, row) => {
							if (val.cod_interno == '') return val.cod;
							else return val.cod_interno;
						},
					},
					{ cod: 'dInicio', fx: this.eDate },
					{ cod: 'dComeco', fx: this.eDate },
					{ cod: 'dTermino', fx: this.eDate },
					{ cod: 'duracao', fx: this.eDate },
					{ cod: 'cnpj', fx: this.get_cnpj },
					{
						cod: 'regiao',
						fx: (val, row) => {
							return `<span class='label label-success'>
							<i class='fa fa-map-marker'></i> ${row.contrato.cod_proposta.regiao}
						</span>`;
						},
					},
				],
			};
		},
		methods: {
			get_cnpj(t) {
				if (Array.isArray(t.type)) return t.client_data.cnpj;
				else return t.sst_data.cnpj;
			},
			eDate(val) {
				if (val == '0000-00-00 00:00:00' || val == null) {
					return '--/--/--';
				} else {
					return eDate(val, 'DD/MM/YY');
				}
			},

			fxStatus(row) {
				if (row.contrato.status == 'suspenso') return 'danger';
				let hoje = new Date();
				let iniPrev = new Date(row.dInicio);
				let fimPrev = new Date(row.duracao);
				let iniReal = new Date(row.dComeco);
				let fimReal = new Date(row.dTermino);

				if (row.status == 0) {
					if (hoje > iniPrev) return 'warning';
					else return '';
				} else if (row.status == 1) {
					if (iniReal > iniPrev) return 'warning';
					else if (hoje > fimPrev) return 'warning';
					else return 'info';
				} else {
					if (iniReal > iniPrev) return 'warning';
					else if (fimReal > fimPrev) return 'warning';
					else return 'success';
				}
			},
		},
	};
</script>



// WEBPACK FOOTER //
// src/components/order-of-service/components/ModeSmartTable/index.vue